function FirmProfileNavIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20"  id="organisation">
      <path
        stroke="#8E33FF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M8.333 7.508l.009-.009M11.667 7.508l.008-.009M8.333 10.842l.009-.01M11.667 10.842l.008-.01M8.333 14.175l.009-.01M11.667 14.175l.008-.01M5 16.9V4.767a.6.6 0 01.6-.6H10V3.1a.6.6 0 01.6-.6h3.8a.6.6 0 01.6.6v13.8a.6.6 0 01-.6.6H5.6a.6.6 0 01-.6-.6z"
      ></path>
    </svg>
  );
}

export default FirmProfileNavIcon;
